import { Button } from "primereact/button";
import { PrimeIcons } from "primereact/api";
import React, { useState } from "react";
import { TawreedTable, TawreedTableProps } from "../../../../../common/components/table";
import { tawreedTranslationService } from "../../../../../common/translations";
import { CssUtils } from "../../../../../helpers/css";
import classNames from 'classnames';
import { BonusDialog } from './bonus-dialog'
import './bonus-table.scss';
import { ColumnBodyOptions } from "primereact/column";
import { TawreedTableEditorCallback } from "../../../../../common/components/table/editors";
import { IBonusType } from "../../../../constants";
import { ObjectUtils } from "../../../../../helpers/object";
import { DiscountTypesBasicsDropDown } from "./discount-types-basics";
import { GlobalContext } from "../../../../../context";
import { JObject } from "../../../../../common/data/models";
import { AuthUtils } from "../../../../auth/domain";
import { TawreedActionName } from "../../../../../common/actions";

export interface BonusType {
    bonus: number;
     quantity: number;
      classificationId:number;
      bonusOperation?: string;  
      sellingPrice?: number;
      bonusType: number;
}

export const BonusTable: React.FC<any> = (props) => {

    const [state, setState] = useState<boolean>(false);
    const { auth: { user }, constants: { constants } } = React.useContext(GlobalContext);


    const hide = () => {
        setState(false);
    }

    const accept = (data: { bonus: number, quantity: number, classificationId:number[],bonusOperation?: string;  sellingPrice?: number }) => {
        if(data.classificationId.length===0)
        {
            props.addBonus([{ ...data, bonusType: props.bonusType, classificationId: undefined }]);
        }
        else{
            let bonus:BonusType[]=[];
            data.classificationId.forEach(element => {
                bonus.push({ ...data, bonusType: props.bonusType, classificationId:element });
                //props.addBonus({ ...data, bonusType: props.bonusType, classificationId:element });
            }); 
            props.addBonus([...bonus]);
        }
        
        hide();
    }

    const deleteBodyButton = (rowData: any, options: ColumnBodyOptions, callback: TawreedTableEditorCallback) => {

        return <Button
            style={{ width: "60%", height: "35px" }}
            icon={PrimeIcons.TRASH}
            className="p-button-danger"
            loading={props.loading}
            onClick={() => {
                props.deleteBonusById(rowData.uniqueId, rowData.bonusId);
            }}
        >
        </Button>
    }

    const tawreed: TawreedTableProps = {
        ds: {
            mode: 'basic',
            data: props.data ? props.data : [],
        },
        name: 'lbl_store_products_bonus',
        dataKey: '',
        columns:
            props.bonusType === IBonusType.EXTRA_ITEMS ? [

                {
                    dataType: 'numeric',
                    field: "quantity",
                    header: "lbl_store_products_bonus_qty",
                    style: CssUtils.width('20%'),
                },
                {
                    dataType: 'numeric',
                    field: "bonus",
                    header: props.bonusType === IBonusType.DISCOUNT ? "lbl_store_products_discount_bonus_val" : "lbl_store_products_bonus",
                    style: CssUtils.width('20%'),
                },
                {
                    dataType: 'string',
                    field: "classificationId",
                    header: "lbl_store_products_class",
                    body:(rowData: any) => {
                        if (rowData['classificationId']) {
                            return constants?.classifications.filter(x=>x.value===rowData['classificationId']).at(0)?.label;
                        }
                        return tawreedTranslationService.translate('lbl_all');
                    },
                    style: CssUtils.width('20%'),
                },
                {
                    dataType: 'numeric',
                    field: "delete",
                    body: (AuthUtils.current().authorized(TawreedActionName.StoreProductsSubmit) && !props.disabeld) ? deleteBodyButton : undefined,
                    style: CssUtils.width('2%'),
                }
            ] : [
                {
                    dataType: 'numeric',
                    field: "quantity",
                    header: "lbl_store_products_bonus_qty",
                    style: CssUtils.width('10%'),
                },
                {
                    dataType: 'text',
                    field: "bonusOperation",
                    header: 'lbl_bonus_operation',
                    style: CssUtils.width('10%'),
                    body: (options: any) => {
                        return constants?.bonusOperations.find(el => el.value === options.bonusOperation)?.label ?? ""
                    }
                },

                {
                    dataType: 'text',
                    field: "discountType",
                    header: 'lbl_price_scheme_discountType',
                    style: CssUtils.width('10%'),
                    body: (options: any) => {
                        console.log(constants?.discountTypes);
                        return constants?.discountTypes.find(el => el.value === options.discountType)?.label ?? ""
                    }
                },
                {
                    dataType: 'numeric',
                    field: "bonus",
                    header: props.bonusType === IBonusType.DISCOUNT ? "lbl_store_products_discount_bonus_val" : "lbl_store_products_bonus",
                    className: CssUtils.className.field.amount,
                    style: CssUtils.width('10%'),
                    body: (options: any) => ObjectUtils.toLocalString(options.bonus, user?.scale!)
                },
                {
                    dataType: 'number',
                    field: "sellingPrice",
                    header: 'lbl_sellingPrice_befor_per_unit',
                    style: CssUtils.width('15%'),
                    body: (options: any) => ObjectUtils.toLocalString(props.singlePrice, user?.scale!)

                }, {
                    dataType: 'number',
                    field: "sellingPrice",
                    header: 'lbl_sellingPrice_befor_after_unit',
                    style: CssUtils.width('20%'),
                    //body: (options: any) => ObjectUtils.toLocalString(getSellingPrice({ discountType: options.discountType, price: props.singlePrice, discountValue: options.bonus }))

                },
                {
                    dataType: 'string',
                    field: "classificationId",
                    header: "lbl_store_products_class",
                    body:(rowData: any) => {
                        if (rowData['classificationId']) {
                            return constants?.classifications.filter(x=>x.value===rowData['classificationId']).at(0)?.label;
                        }
                        return tawreedTranslationService.translate('lbl_all');
                    },
                    style: CssUtils.width('10%'),
                },
                {
                    dataType: 'numeric',
                    field: "delete",
                    body: (AuthUtils.current().authorized(TawreedActionName.StoreProductsSubmit) && !props.disabeld) ? deleteBodyButton :undefined,
                    style: CssUtils.width('8%'),
                }

            ],
        header: {
            left: {
                search: false,
                custom: (
                    <span>
                        {tawreedTranslationService.translate(props.title)}
                    </span>
                )
            },
            right: AuthUtils.current().authorized(TawreedActionName.StoreProductsSubmit) ? {
                clear: false,
                custom: (
                    !props.disabeld &&
                    <div className="formgroup-inline">
                        <i className={classNames(PrimeIcons.PLUS, 'bouns_table_plus')} onClick={() => setState(true)}></i>
                    </div>
                )
            }:undefined
        }
    };

    return (
        <React.Fragment>
            <div className="col-12 md:col-12"><TawreedTable {...tawreed} /></div>
            <BonusDialog
                visible={state}
                singlePrice={props.singlePrice}
                hide={hide}
                isDiscount={props.bonusType === IBonusType.DISCOUNT}
                accept={accept}
            ></BonusDialog>
        </React.Fragment>
    );

}
